// extracted by mini-css-extract-plugin
export default {"Box":"Table-module__Box--KyMHK","Box_1":"Table-module__Box_1--DkRqs","Box_2":"Table-module__Box_2--l1wjV","Box_3":"Table-module__Box_3--CeioY","Box_4":"Table-module__Box_4--xPnSl"};